export default __webpack_public_path__ + "images/IQ.b819b19.png";